import React from "react";
import { Helmet } from "react-helmet-async";

const Title = ({ title, content }) => {
  return (
    <div>
      <Helmet>
        <title>{title} - Raxmart</title>
        <meta name={title} content={content} />
        <link rel="canonical" href={window.location.origin + '/'} />
      </Helmet>
    </div>
  );
};

export default Title;
